import { BOLD } from '@lumapps/wrex-typography/constants';
import type { Bold } from '@lumapps/wrex-typography/types';
import { Path, ReactEditor, Text, Transforms } from '@lumapps/wrex/slate';

/**
 * Add (or remove, with `isBold` set to `false`) the bold mark on every text node contained in
 * the given cells.
 */
export const setBoldOnCells = (editor: ReactEditor, cellPaths: Path[], isBold = true) => {
    cellPaths.forEach((cellPath) => {
        const textNodesInCell = { at: cellPath, match: Text.isText, mode: 'lowest', voids: true } as const;
        if (isBold) {
            Transforms.setNodes<Text & Bold>(editor, { [BOLD]: true }, textNodesInCell);
        } else {
            Transforms.unsetNodes(editor, BOLD, textNodesInCell);
        }
    });
};
